import React from 'react';

import Grid from '@material-ui/core/Grid';

import Hello from './Hello';
import Navigation from './Navigation';

import '../Main.css';

export default function Header() {
    return(
        <div>
            <Grid
                container
                direction="row"
                justify="space-between"
                alignItems="center"
            >
                <Grid item className="hello">
                    <Hello></Hello>
                </Grid>
                <Grid item className="navigation">
                    <Navigation></Navigation>
                </Grid>
            </Grid>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/Header.jsx